class StoreRegistration {
  constructor() {
    this.emailValue = '';
    this.firstNameValue = '';
    this.lastNameValue = '';
    this.form = document.getElementById('create_customer');
    this.successMessage = document.getElementById('success-message');
    this.formContainer = document.getElementById('registration-form-container');
    this.backButton = document.getElementById('back-button');
    this.imageSection = document.getElementById('image-section');
    this.registrationContainer = document.getElementById('registration-container');

    this.errorModal = document.querySelector('.form-errors-modal');
    this.loyaltyModal = document.getElementById('loyalty-modal');
    this.passwordModal = document.getElementById('password-modal');
    const giftlistDomain = (window.DreambabyConfig && window.DreambabyConfig.giftlistDomain);

    this.customerInviteEndpointUrl = `${giftlistDomain}/proxy/shopify-admin/customer-invite?authorization=fixed`;
    this.customerConsentEndpointUrl = `${giftlistDomain}/proxy/shopify-admin/customer-consent?authorization=fixed`;

    this.adminHandler = new DreambabyAdminRequestHandler();

    this.customerMailHandler = new DreambabyCustomerMailHandler({
      endpointUrl: this.customerInviteEndpointUrl,
      proxyToken: (window.DreambabyConfig && window.DreambabyConfig.proxyToken)
    });

    if (!this.registrationContainer) {
      return;
    }

    this.requestPasswordButton = this.passwordModal ? this.passwordModal.querySelector('.request-password') : null;

    this.emailInput = this.form ? this.form.elements['customer[email]'] : null;
    this.firstNameInput = this.form ? this.form.elements['customer[first_name]'] : null;
    this.lastNameInput = this.form ? this.form.elements['customer[last_name]'] : null;
    this.returnToInput = this.form ? this.form.elements['return_to'] : null;

    this.loyaltyCheckbox = document.getElementById('loyalty');
    this.marketingCheckbox = document.getElementById('marketing');
    this.loyaltyModalLoyaltyCheckbox = document.getElementById('loyalty-modal-loyalty');
    this.loyaltyModalMarketingCheckbox = document.getElementById('loyalty-modal-marketing');
    this.confirmLoyaltyButton = document.getElementById('confirm-loyalty-button');
    this.loyaltyModalError = document.querySelector('.loyalty-modal-error');

    this.init();
  }

  init() {
    this.setupStateSync();
    this.setupEmailSync();
    this.checkRegistrationSuccess();
    this.setupBackButton();
    this.checkImageSection();
    this.generateRandomPassword();
    this.setupModalCloseButtons();
    this.setupRequestPassword();
    this.handleExistingCustomer();
    this.setupLoyaltyModal();
    this.setupLoyaltyCheckboxHandler();
  }

  setupLoyaltyCheckboxHandler() {
    if (this.isEmailExistsModalHandledElsewhere()) {
      return;
    }

    if (!this.loyaltyModalLoyaltyCheckbox || !this.loyaltyModalMarketingCheckbox) {
      return;
    }

    new DreambabyLoyaltyCheckboxHandler(this.loyaltyModalLoyaltyCheckbox.id, this.loyaltyModalMarketingCheckbox.id);

    this.updateLoyaltyConfirmButton();

    this.loyaltyModalLoyaltyCheckbox.addEventListener('change', () => {
      this.updateLoyaltyConfirmButton();
    });

    this.loyaltyModalMarketingCheckbox.addEventListener('change', () => {
      this.updateLoyaltyConfirmButton();
    });
  }

  generateRandomPassword() {
    if (!this.form) {
      return;
    }

    const passwordField = this.form.querySelector('input[name="customer[password]"]');
    if (passwordField) {
      const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
      passwordField.value = Array(16).fill().map(() => chars.charAt(Math.floor(Math.random() * chars.length))).join('');
    }
  }

  checkImageSection() {
    if (this.imageSection && this.registrationContainer) {
      const imageContent = this.imageSection.innerHTML.trim();

      if (!imageContent || imageContent === '' || !this.imageSection.querySelector('img')) {
        this.registrationContainer.classList.add('no-image');
      }
    }
  }

  checkRegistrationSuccess() {
    const liquidErrorsElement = document.querySelector('.form-message--error');

    if (!window.location.search.includes('registration_posted=true') || liquidErrorsElement) {
      this.successMessage.style.display = 'none';
      this.formContainer.style.display = 'block';
      return;
    }

    if (liquidErrorsElement) {
      this.successMessage.style.display = 'none';
      this.formContainer.style.display = 'block';
      return;
    }

    this.successMessage.style.display = 'block';
    this.formContainer.style.display = 'none';
    this.logoutCustomer();

    if (this.emailValue) {
      setTimeout(() => {
        this.customerMailHandler.triggerResetPassword(this.emailValue);
      }, 5000);
    }

    setTimeout(() => {
      this.redirectToCleanPage();
    }, 30000);
  }

  handleMailSuccess() {
    this.passwordModal.querySelector('.form__success')?.classList.add('is-visible');
    this.passwordModal.querySelector('.form-message--error').style.display = 'none';

    setTimeout(() => {
      this.redirectToCleanPage();
    }, 30000);
  }

  setupRequestPassword() {
    if (!this.requestPasswordButton) {
      return;
    }

    this.requestPasswordButton.addEventListener('click', async () => {
      this.requestPasswordButton.classList.add('loading');
      const email = sessionStorage.getItem('registrationEmail');
      if (email) {
        this.customerMailHandler.triggerResetPassword(email);

        setTimeout(() => {
          this.customerMailHandler.triggerActivateAccount(email);
          this.handleMailSuccess();
        }, 2000);
      }
    });
  }

  logoutCustomer() {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = '/account/logout';
    document.body.appendChild(iframe);

    setTimeout(() => {
      if (iframe && iframe.parentNode) {
        iframe.parentNode.removeChild(iframe);
      }
    }, 1000);
  }

  redirectToCleanPage() {
    window.location.href = window.location.pathname;
  }

  setupBackButton() {
    if (this.backButton) {
      this.backButton.addEventListener('click', () => {
        this.redirectToCleanPage();
      });
    }
  }

  setupEmailSync() {
    if (!this.emailInput) {
      return;
    }

    const emailFromSession = sessionStorage.getItem('registrationEmail');

    if (emailFromSession) {
      this.emailValue = emailFromSession;
    }

    const updateReturnToUrl = () => {
      if (!this.returnToInput) {
        return;
      }
      let returnToPath = `${window.location.pathname}?registration_posted=true`;
      this.returnToInput.value = returnToPath;
    };

    updateReturnToUrl();

    this.emailInput.addEventListener('input', (e) => {
      this.emailValue = e.target.value;
      sessionStorage.setItem('registrationEmail', this.emailValue);
      updateReturnToUrl();
    });
  }

  setupModalCloseButtons() {
    const modals = [this.loyaltyModal, this.passwordModal];

    modals.forEach(modal => {
      if (!modal) {
        return;
      }

      const innerModal = modal.querySelector('.form-errors-modal-inner');
      const closeButton = modal.querySelector('.close-modal-x');
      const closeErrorButton = modal.querySelector('.close-error-modal-button');
      const closeSuccessButton = modal.querySelector('.close-success-modal-button');

      const closeModal = () => {
        if (!innerModal) return;

        fadeOutModal(modal);
        sessionStorage.removeItem('registrationEmail');
        sessionStorage.removeItem('registrationFirstName');
        sessionStorage.removeItem('registrationLastName');
        sessionStorage.removeItem('registrationLoyalty');
        sessionStorage.removeItem('registrationMarketing');
        this.redirectToCleanPage();
      };

      if (closeButton) {
        closeButton.addEventListener('click', closeModal);
      }

      if (closeErrorButton) {
        closeErrorButton.addEventListener('click', closeModal);
      }

      if (closeSuccessButton) {
        closeSuccessButton.addEventListener('click', () => {
          closeModal();
        });
      }

      modal.addEventListener('click', (event) => {
        if (event.target === modal) {
          closeModal();
        }
      });
    });
  }

  handleExistingCustomer() {
    const emailExistsError = this.errorModal && this.errorModal.classList.contains('is-email-exists-error');
    if (!emailExistsError) {
      return;
    }
    this.showLoyaltyModal();
  }

  showLoyaltyModal() {
    if (!this.loyaltyModal) {
      return;
    }

    this.loyaltyModalLoyaltyCheckbox.checked = sessionStorage.getItem('registrationLoyalty') === 'true';
    this.loyaltyModalMarketingCheckbox.checked = sessionStorage.getItem('registrationMarketing') === 'true';

    this.loyaltyModal.style.display = 'flex';

    fadeInModal(this.loyaltyModal);
  }

  updateCustomerConsent() {
    this.adminHandler.updateCustomerConsent(this.emailValue, !!this.loyaltyModalLoyaltyCheckbox.checked, !!this.loyaltyModalMarketingCheckbox.checked)
      .then(() => {
        this.loyaltyModalError.classList.add('is-hidden');
        fadeOutModal(this.loyaltyModal);

        const passwordHeader = this.passwordModal.querySelector('.password-modal-header');
        if (passwordHeader) {
          setTimeout(() => {
            passwordHeader.classList.add('is-visible');
          }, 500);
        }
        fadeInModal(this.passwordModal);
      })
      .catch(error => {
        this.loyaltyModalError.classList.remove('is-hidden');
        console.error('Error updating customer consent:', error);
      })
      .finally(() => {
        this.confirmLoyaltyButton.classList.remove('loading');
      });
  }

  isEmailExistsModalHandledElsewhere() {
    // DreambabyEmailExistsHandler already owns the confirm button in this case.
    return !!(this.errorModal && this.errorModal.classList.contains('loyalty-modal'));
  }

  setupLoyaltyModal() {
    if (this.isEmailExistsModalHandledElsewhere()) {
      return;
    }

    if (!this.confirmLoyaltyButton) {
      return;
    }

    this.confirmLoyaltyButton.addEventListener('click', () => {
      this.confirmLoyaltyButton.classList.add('loading');

      this.updateCustomerConsent();
    });
  }

  setupStateSync() {
    this.firstNameInput.addEventListener('input', (event) => {
      sessionStorage.setItem('registrationFirstName', event.target.value);
    });

    this.lastNameInput.addEventListener('input', (event) => {
      sessionStorage.setItem('registrationLastName', event.target.value);
    });

    this.setupCheckboxSync(this.loyaltyCheckbox, this.loyaltyModalLoyaltyCheckbox, 'registrationLoyalty');
    this.setupCheckboxSync(this.marketingCheckbox, this.loyaltyModalMarketingCheckbox, 'registrationMarketing');
    this.setupCheckboxSync(this.loyaltyModalLoyaltyCheckbox, this.loyaltyCheckbox, 'registrationLoyalty');
    this.setupCheckboxSync(this.loyaltyModalMarketingCheckbox, this.marketingCheckbox, 'registrationMarketing');

    if (!window.location.search.includes('registration_posted=true')) {
      return;
    }

    if (sessionStorage.getItem('registrationEmail')) {
      this.emailInput.value = sessionStorage.getItem('registrationEmail');
    }
    if (sessionStorage.getItem('registrationFirstName')) {
      this.firstNameInput.value = sessionStorage.getItem('registrationFirstName');
    }
    if (sessionStorage.getItem('registrationLastName')) {
      this.lastNameInput.value = sessionStorage.getItem('registrationLastName');
    }

    const loyaltyChecked = sessionStorage.getItem('registrationLoyalty') === 'true';
    const marketingChecked = sessionStorage.getItem('registrationMarketing') === 'true';

    this.loyaltyCheckbox.checked = loyaltyChecked;
    if (this.loyaltyModalLoyaltyCheckbox) {
      this.loyaltyModalLoyaltyCheckbox.checked = loyaltyChecked;
    }

    this.marketingCheckbox.checked = marketingChecked;
    if (this.loyaltyModalMarketingCheckbox) {
      this.loyaltyModalMarketingCheckbox.checked = marketingChecked;
    }
  }

  setupCheckboxSync(checkboxA, checkboxB, storageKey) {
    if (!checkboxA) {
      return;
    }
    const syncState = (event) => {
      const isChecked = event.target.checked;
      sessionStorage.setItem(storageKey, isChecked);
      checkboxA.checked = isChecked;
      if (!checkboxB) {
        return;
      }
      checkboxB.checked = isChecked;
    };

    checkboxA.addEventListener('change', syncState);
    if (!checkboxB) {
      return;
    }
    checkboxB.addEventListener('change', syncState);
  }

  updateLoyaltyConfirmButton() {
    if (this.loyaltyModalLoyaltyCheckbox.checked || this.loyaltyModalMarketingCheckbox.checked) {
      this.confirmLoyaltyButton.querySelector('.button__text').innerHTML = this.confirmLoyaltyButton.getAttribute('data-button-text-with-checkboxes');
      return;
    }

    this.confirmLoyaltyButton.querySelector('.button__text').innerHTML = this.confirmLoyaltyButton.getAttribute('data-button-text-no-checkboxes');
  }
}

function fadeInModal(modal) {
  if (!modal) {
    return;
  }
  modal.style.display = 'flex';
  const innerModal = modal.querySelector('.form-errors-modal-inner');
  innerModal.classList.add('fade-in');
  innerModal.addEventListener('animationend', () => {
    innerModal.classList.remove('fade-in');
  }, { once: true });
}

function fadeOutModal(modal) {
  if (!modal) {
    return;
  }
  const innerModal = modal.querySelector('.form-errors-modal-inner');
  modal.classList.add('fade-out');
  innerModal.addEventListener('animationend', () => {
    modal.classList.remove('fade-out');
    modal.style.display = 'none';
  }, { once: true });
}

document.addEventListener('DOMContentLoaded', () => {
  new StoreRegistration();
});
